import { bool, shape } from 'prop-types'

export const featureTogglesType = shape({
  pickupStationsActive: bool,
})
